import script from "./DispatchHistory.vue?vue&type=script&lang=ts&setup=true"
export * from "./DispatchHistory.vue?vue&type=script&lang=ts&setup=true"

import "./DispatchHistory.vue?vue&type=style&index=0&id=07d1f656&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07d1f656"]])

export default __exports__